/**
 * Round 50: links to GEMS's own pages inside a message become tappable
 * (a tournament invitation from GEMS carries its page link). Only links to
 * this site are turned into links — an address somebody else typed stays text.
 */
import React from 'react';

const OWN_HOSTS = ['gemslive.tv', 'www.gemslive.tv'];
const URL_RE = /(https:\/\/[^\s<>"']+)/g;

const isOwn = (url) => {
  try {
    const host = new URL(url).hostname.toLowerCase();
    return OWN_HOSTS.includes(host) || host === window.location.hostname.toLowerCase();
  } catch (e) { return false; }
};

export const ownLinks = (text) => String(text || '').split(URL_RE).map((part, i) => {
  if (i % 2 === 0) return part;
  const url = part.replace(/[.,!?)]+$/, '');
  if (!isOwn(url)) return part;
  return (
    <React.Fragment key={i}>
      <a href={url} target="_blank" rel="noopener noreferrer" className="underline font-semibold break-all" data-testid="message-own-link">{url}</a>
      {part.slice(url.length)}
    </React.Fragment>
  );
});

export default ownLinks;
